import { useMemo, useState } from 'react';
import cn from 'classnames';
import { ConfirmationModal, Typography, extractPureTextFromRichText, useOverlayContext, TextButton } from 'seagull';
import ServiceDescriptionContent from "../../ServiceDescriptionContent/ServiceDescriptionContent";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import styles from "./ServiceDescription.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ServiceDescription(_ref) {
  var _service$bundle2;
  let {
    service,
    testId,
    isMobile,
    showReadMoreButton = true
  } = _ref;
  const [isDescriptionOverflowing, setIsDescriptionOverflowing] = useState(false);
  const {
    showModal
  } = useOverlayContext();
  const {
    INLINE_EDIT_SERVICE_NAME_DESCRIPTION = false
  } = useFeatureFlags();
  const hasBundleDescription = useMemo(() => {
    var _service$bundle;
    return (_service$bundle = service.bundle) === null || _service$bundle === void 0 ? void 0 : _service$bundle.services.some(service => service.description);
  }, [(_service$bundle2 = service.bundle) === null || _service$bundle2 === void 0 ? void 0 : _service$bundle2.services]);
  const pureTextDescription = useMemo(() => extractPureTextFromRichText(service.description), [service.description]);
  const hasReadMoreButton = !isMobile && showReadMoreButton && (isDescriptionOverflowing || hasBundleDescription);
  function getFullDescription() {
    return /*#__PURE__*/_jsx(ServiceDescriptionContent, {
      description: service.description,
      includedServices: service.bundle ? service.bundle.services : null,
      testId: testId
    });
  }
  function getCutDescription() {
    return isDescriptionOverflowing && hasBundleDescription && service.description !== '' || hasReadMoreButton ? "".concat(pureTextDescription, "...") : pureTextDescription;
  }
  function handleReadMore() {
    showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(ConfirmationModal, {
          title: service.name,
          textAlignCenter: false,
          onPrimaryButtonClick: dismissModal,
          onCloseButtonClick: dismissModal,
          primaryButtonLabel: "OK",
          content: getFullDescription()
        });
      }
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: styles.descriptionWrapper,
    "data-testid": "".concat(testId, "service-details-description"),
    children: [service.description && /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      hideTooltip: true,
      className: cn(styles.description, {
        [styles.fullWidth]: !showReadMoreButton && INLINE_EDIT_SERVICE_NAME_DESCRIPTION
      }),
      ref: el => el && setIsDescriptionOverflowing(el.clientWidth < el.scrollWidth),
      skin: "secondary",
      testId: testId + 'description',
      children: isMobile ? getFullDescription() : getCutDescription()
    }), hasReadMoreButton && /*#__PURE__*/_jsx(TextButton, {
      onClick: e => {
        e.stopPropagation();
        handleReadMore();
      },
      className: styles.readMoreButton,
      testId: testId + 'read-more-button',
      children: "Read more"
    })]
  });
}